import React, { useEffect, useState } from 'react';
import {
  Button,
  Box,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  ListItemIcon,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { Field, Form, Formik } from 'formik';
import { LoadingButton } from '@mui/lab';
import { startLoadingRols, startNewUser } from '../../redux/actions/users';
import { useFormStyles } from '../../styles/formStyles';

import showPassword from '@/images/show-password.svg';
import hidePassword from '@/images/hide-password.svg';
import { validationSchemaUser } from '../../utils/schemaValidationForm';
import { loadGridUser } from '../../helpers/loadGrid';

import { LocalizationProvider } from '@mui/x-date-pickers';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import { CustomizedSelect } from '../ui/CustomizedSelect';
import { ROLREVENDEDOR } from '../../utils/constants';
import {
  AccountCircleRounded,
  ApartmentOutlined,
  HomeOutlined,
  Euro,
  InsertLinkOutlined,
} from '@material-ui/icons';
import { startLogOutContentModal } from '../../redux/actions/contentModal';
import { uiManageModalCollectionTypes } from '../../redux/actions/ui';
import { SwitchMUI } from '../ui/Switch';
import { loadCurrencies } from '../../helpers/loadCurrencies';
import { useAppSelector } from '@/hooks/useAppSelector';
import { Address } from '@/types/address/address';
import { StandardAutocomplete } from '@/components/ui/StandardAutocomplete';
import { getCountries } from '@/redux/actions/countryService';
import { SelectOption } from '@/types/forms/select-option';
import { ForceOtroDocumentoProbatorioEffect } from '@/helpers/formik-effects/forceOtroDocumentoProbatorioEffect';
import { shouldForceOtroDocumentoProbatorio } from '@/utils/nemonIntegration';

export const ContentModalUserAdd = () => {
  const { active } = useAppSelector(state => state.user);
  const { id: idLoggedUser } = useAppSelector(state => state.auth);
  const { roles } = useAppSelector(state => state.roles);
  const dispatch = useDispatch(); //react-redux hook to be able to dispatch the actions
  const [visible, setVisible] = useState(false); //password type ('password' o 'text') state management
  const classes = useFormStyles(); //the classes variable to handle the form styles
  const { data } = loadGridUser();
  const result = data.filter(e => e?.type !== 'detail');
  const result_data = result.filter(e => e?.filter !== 'notAdd');
  const currencies = loadCurrencies();
  const tiposUsuarioValidos = {
    agencia: 2,
    particular: 1,
  };
  const { countries } = useAppSelector(state => state.country);

  const countryOptions: SelectOption[] = countries.map(country => ({
    label: country.Nombre,
    value: country.PkPaises,
  }));

  const alwaysRequired = ['name', 'email', 'password', 'telefono'];
  const revendedorRequired = ['NIF', 'Direccion', 'FkPaises', 'CodigoPostal', 'Municipio', 'Provincia'];

  const isFieldRequired = (fieldName: string, rol: number, tipoUsuario: number, esEmpresa: boolean) => {
    if (alwaysRequired.includes(fieldName)) return true;
    if (rol === ROLREVENDEDOR && revendedorRequired.includes(fieldName)) return true;
    if (fieldName === 'surname' && rol === ROLREVENDEDOR && !(esEmpresa)) return true;
    if (fieldName === 'nombrePersonaFisica' && rol === ROLREVENDEDOR && tipoUsuario === 2 && !esEmpresa) return true;
    return false;
  };

  useEffect(() => {
    dispatch(startLoadingRols());
    dispatch(getCountries());
  }, [dispatch]);

  interface FormValues extends Address {
    name: string;
    nombrePersonaFisica: string;
    surname: string;
    email: string;
    password: string;
    rol: number;
    telefono: string;
    observaciones: string;
    date?: string;
    tipoUsuario: number;
    razonSocial: string;
    Direccion: string;
    UrlB2B: string;
    NIF: string;
    CodigoLicencia: string;
    Comisiona: boolean;
    ComisionaPorImporte: boolean;
    MargenConfiguradoEnServicios: boolean;
    Moneda: string;
    EsHotel: boolean;
    EsAgencia: boolean;
    EsEmpresa: boolean;
    OtroDocumentoProbatorio: boolean;
    ImporteComision: number;
    ImporteComisionDescuento: number;
    PorcentajeComision: number;
  }

  const initialValues: FormValues = {
    name: '',
    nombrePersonaFisica: '',
    surname: '',
    email: '',
    password: '',
    rol: -1,
    telefono: '',
    observaciones: '',
    date: null,
    tipoUsuario: 1,
    razonSocial: '',
    UrlB2B: '',
    NIF: '',
    CodigoLicencia: '',
    Comisiona: false,
    ComisionaPorImporte: false,
    MargenConfiguradoEnServicios: false,
    Moneda: '',
    EsHotel: false,
    EsAgencia: false,
    EsEmpresa: false,
    OtroDocumentoProbatorio: false,
    Direccion: '',
    Numero: '',
    Piso: '',
    DireccionComplementaria: '',
    CodigoPostal: '',
    Municipio: '',
    Provincia: '',
    FkPaises: 69,
    ImporteComision: 0,
    ImporteComisionDescuento: 0,
    PorcentajeComision: 0,
    // TODO-af: Add IdNemon
  };

  const handleSubmit = (values: FormValues, { setSubmitting }) => {
    const esAgencia = values.tipoUsuario === 2 ? true : false;
    const esEmpresa = esAgencia && values.EsEmpresa;

    const user = {
      Nombre: values.name,
      Apellidos: values.surname,
      Email: values.email,
      FkRoles: values.rol,
      PasswordHash: values.password,
      CambioPassword: false,
      AceptaPoliticas: false,
      Telefono: values.telefono,
      Observaciones: values.observaciones ? values.observaciones : '',
      UsuarioAlta: idLoggedUser,
      FechaBaja: values.date,
      VersionFila: 0,
      EsHotel: values.EsHotel,
      Direccion: values.Direccion,
      Numero: values.Numero,
      Piso: values.Piso,
      DireccionComplementaria: values.DireccionComplementaria,
      CodigoPostal: values.CodigoPostal,
      Municipio: values.Municipio,
      Provincia: values.Provincia,
      FkPaises: values.FkPaises,
    };

    const payload = {
      ...user,
      EsAgencia: esAgencia,
      EsEmpresa: esEmpresa,
      RazonSocial: esEmpresa ? values.razonSocial : '',
      Direccion: values.tipoUsuario === 2 ? values.Direccion : '',
      UrlB2B: values.tipoUsuario === 2 ? values.UrlB2B : '',
      NIF: values.tipoUsuario === 1 || values.tipoUsuario === 2 ? values.NIF : '',
      CodigoLicencia: values.CodigoLicencia ?? '',
      ImporteComision: values.tipoUsuario === 2 ? +values.ImporteComision : 0,
      ImporteComisionDescuento: values.tipoUsuario === 2 ? +values.ImporteComisionDescuento : 0,
      PorcentajeComision: values.tipoUsuario === 2 ? +values.PorcentajeComision : 0,
      ComisionaPorImporte: values.tipoUsuario === 2 ? values.ComisionaPorImporte ?? false : false,
      Comisiona: values.tipoUsuario === 2 ? values.Comisiona ?? false : false,
      NombrePersonaFisica: values.tipoUsuario === 2 ? values.nombrePersonaFisica : '',
      Moneda: values.Moneda,
      MargenConfiguradoEnServicios: values.MargenConfiguradoEnServicios,
      OtroDocumentoProbatorio: values.OtroDocumentoProbatorio,
    };

    // TODO-af: Delete this
    console.log('values', values);
    console.log('payload', payload);

    dispatch(startNewUser(payload, setSubmitting)); //we dispatch the action to create a new user
  };

  const handleCancel = () => {
    dispatch(startLogOutContentModal());
    dispatch(uiManageModalCollectionTypes());
  };

  /**
   * The HTML is being rendered
   */
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchemaUser}
        onSubmit={handleSubmit}>
        {({ handleChange, errors, handleBlur, isSubmitting, touched, isValid, values, setFieldValue }) => {

        const selectedCountry = countries.find(c => c.PkPaises === values.FkPaises);

          const esEmpresa = values.tipoUsuario === tiposUsuarioValidos.agencia && values.EsEmpresa;

        const getDocumentoLabel = () => {
          if (values.OtroDocumentoProbatorio) return 'ID';
          if (esEmpresa) {
            if (selectedCountry?.Codigo?.toLowerCase() === 'es') return 'CIF';
            if (selectedCountry?.EsIntracomunitario) return 'VAT Number';
            return 'ID';
          }
          return selectedCountry?.Codigo?.toLowerCase() === 'es' ? 'NIF' : 'ID';
        };
        
        const forceOtroDocumentoProbatorio = selectedCountry
          ? shouldForceOtroDocumentoProbatorio(
              selectedCountry.Codigo,
              selectedCountry?.EsIntracomunitario,
            esEmpresa
            )
          : false;

        return (
          <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <ForceOtroDocumentoProbatorioEffect countries={countries} />
            <Grid item style={{ padding: '2rem' }}>
              <Grid container direction="column">
                <Grid item classes={{ root: classes.container }}>
                  <Typography variant="h3">Agregar Usuario</Typography>
                </Grid>

                {/* 1. Selector de Roles - Primera posición */}
                <Grid item classes={{ root: classes.container }}>
                  <Box>
                    <FormControl
                      fullWidth
                      disabled={isSubmitting}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={touched.rol && Boolean(errors.rol)}
                    >
                      <InputLabel style={{ fontSize: '0.8em' }} id="select-label-roles">
                        Roles
                      </InputLabel>
                      <Field name="rol" component={CustomizedSelect}>
                        {roles.map((rol, i) => {
                          return (
                            <MenuItem style={{ fontSize: '0.7em' }} key={i} value={rol.PkRoles}>
                              {rol.Nombre}
                            </MenuItem>
                          );
                        })}
                      </Field>
                    </FormControl>
                  </Box>
                </Grid>

                {/* 2. Tipo de Usuario - Segunda posición (solo si es Revendedor) */}
                {values.rol === ROLREVENDEDOR && (
                  <Grid item classes={{ root: classes.container }}>
                    <FormControl
                      fullWidth
                      style={{ marginBottom: '1rem' }}
                      disabled={isSubmitting}
                      onBlur={handleBlur}
                      error={touched.tipoUsuario && Boolean(errors.tipoUsuario)}
                    >
                      <InputLabel style={{ fontSize: '0.8em' }} id="select-label-type-services">
                        Tipo Usuario
                      </InputLabel>
                      <Select
                        style={{ fontSize: '0.7em' }}
                        name="tipoUsuario"
                        value={values.tipoUsuario}
                        onChange={(e) => {
                          const val = e.target.value as number;
                          setFieldValue('tipoUsuario', val);
                          setFieldValue('EsEmpresa', val === tiposUsuarioValidos.agencia);
                        }}
                      >
                        <MenuItem style={{ fontSize: '0.7em' }} value={2}>
                          Agencia
                        </MenuItem>
                        <MenuItem style={{ fontSize: '0.7em' }} value={1}>
                          Particular
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                )}

                {values.rol === ROLREVENDEDOR &&
                  (values.tipoUsuario === tiposUsuarioValidos.agencia ||
                    values.tipoUsuario === tiposUsuarioValidos.particular) && (
                    <Grid container spacing={3}>
                      {values.tipoUsuario === tiposUsuarioValidos.agencia && (
                        <Grid item md={4} xs={12}>
                          <SwitchMUI
                            label="Es empresa"
                            name="EsEmpresa"
                            values={values}
                            setFieldValue={setFieldValue}
                            style={undefined}
                            disabled={isSubmitting}
                          />
                        </Grid>
                      )}
                      <Grid item md={4} xs={12}>
                        <SwitchMUI
                          label={(() => {
                            const selectedCountry = countries.find(c => c.PkPaises === values.FkPaises);
                            return selectedCountry?.Codigo?.toLowerCase() === 'es' ? 'No censado' : 'Otro documento probatorio';
                          })()}
                          name="OtroDocumentoProbatorio"
                          values={values}
                          setFieldValue={setFieldValue}
                          style={undefined}
                          disabled={forceOtroDocumentoProbatorio}
                        />
                      </Grid>
                      <Grid classes={{ root: classes.container }} key="NIF" item md={12} xs={12}>
                        <TextField
                          fullWidth
                          name="NIF"
                          size="small"
                          classes={{ root: classes.inputText }}
                          id={`outlined-basic-NIF`}
                          label={getDocumentoLabel()}
                          variant="outlined"
                          InputProps={{
                            classes: {
                              input: classes.resize,
                            },
                          }}
                          InputLabelProps={{ style: { fontSize: '0.8em' } }}
                          value={values['NIF']}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={touched['NIF'] && Boolean(errors['NIF'])}
                          helperText={touched['NIF'] && (errors['NIF'] as string)}
                          disabled={isSubmitting}
                          required
                        />
                      </Grid>
                    </Grid>
                  )}

                {/* 4. Resto de campos */}
                {result_data.map(element => {
                  const esAgenciaRevendedor =
                    values.rol === ROLREVENDEDOR && values.tipoUsuario === tiposUsuarioValidos.agencia;

                  if (element.name === 'surname' && esAgenciaRevendedor) {
                    return (
                      <React.Fragment key="nombrePersonaFisica-surname-group">
                        <Grid item classes={{ root: classes.container }}>
                          <TextField
                            fullWidth
                            name="nombrePersonaFisica"
                            size="small"
                            classes={{ root: classes.inputText }}
                            id="outlined-basic-nombrePersonaFisica"
                            label="Nombre"
                            variant="outlined"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <AccountCircleRounded />
                                </InputAdornment>
                              ),
                              classes: { input: classes.resize },
                            }}
                            InputLabelProps={{ style: { fontSize: '0.8em' } }}
                            value={values.nombrePersonaFisica}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            error={touched.nombrePersonaFisica && Boolean(errors.nombrePersonaFisica)}
                            helperText={
                              touched.nombrePersonaFisica && (errors.nombrePersonaFisica as string)
                            }
                            disabled={isSubmitting}
                            required={isFieldRequired(
                              'nombrePersonaFisica',
                              values.rol,
                              values.tipoUsuario,
                              values.EsEmpresa,
                            )}
                          />
                        </Grid>
                        <Grid item classes={{ root: classes.container }}>
                          <TextField
                            fullWidth
                            name="surname"
                            size="small"
                            type="text"
                            classes={{ root: classes.inputText }}
                            id="outlined-basic-surname"
                            label="Apellidos"
                            variant="outlined"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  {element.startAdornment}
                                </InputAdornment>
                              ),
                              classes: { input: classes.resize },
                            }}
                            InputLabelProps={{ style: { fontSize: '0.8em' } }}
                            value={values.surname}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            error={touched.surname && Boolean(errors.surname)}
                            helperText={touched.surname && (errors.surname as string)}
                            disabled={isSubmitting}
                            required={isFieldRequired(
                              'surname',
                              values.rol,
                              values.tipoUsuario,
                              values.EsEmpresa,
                            )}
                          />
                        </Grid>
                      </React.Fragment>
                    );
                  }

                  if (element.name === 'FkPaises') {
                    return (
                      <StandardAutocomplete
                        key={element.name}
                        name={element.name}
                        label={'País'}
                        value={values.FkPaises}
                        onChange={val => setFieldValue('FkPaises', Number(val))}
                        options={countryOptions}
                        required={isFieldRequired(
                          element.name,
                          values.rol,
                          values.tipoUsuario,
                          values.EsEmpresa,
                        )}
                      />
                    );
                  }

                  return (
                    <Grid key={element.name} item classes={{ root: classes.container }}>
                      <TextField
                        fullWidth
                        name={element.name}
                        size="small"
                        type={element.name === 'password' ? (visible ? 'text' : 'password') : 'text'}
                        classes={{ root: classes.inputText }}
                        id={`outlined-basic-${element.name}`}
                        label={
                          element.name === 'name' && esAgenciaRevendedor
                            ? 'Nombre comercial'
                            : element.label
                        }
                        variant="outlined"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              {element.name === 'name' && values.tipoUsuario === 2 ? (
                                <ApartmentOutlined />
                              ) : (
                                element.startAdornment
                              )}
                            </InputAdornment>
                          ),
                          endAdornment: element?.endAdornment && (
                            <InputAdornment position="end" onClick={() => setVisible(!visible)}>
                              <img
                                src={visible ? showPassword : hidePassword}
                                alt="eye-password"
                                style={{ cursor: 'pointer' }}
                              />
                            </InputAdornment>
                          ),
                          classes: { input: classes.resize },
                        }}
                        InputLabelProps={{ style: { fontSize: '0.8em' } }}
                        value={values[element.name]}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={touched[element.name] && Boolean(errors[element.name])}
                        helperText={touched[element.name] && (errors[element.name] as string)}
                        disabled={isSubmitting}
                        multiline={element.name === 'observaciones' ? true : false}
                        maxRows={element.name === 'observaciones' ? 10 : undefined}
                        minRows={element.name === 'observaciones' ? 5 : undefined}
                        required={isFieldRequired(
                          element.name,
                          values.rol,
                          values.tipoUsuario,
                          values.EsEmpresa,
                        )}
                      />
                    </Grid>
                  );
                })}

                <Grid item md={6} xs={12} classes={{ root: classes.container }}>
                  <Box>
                    <FormControl
                      fullWidth
                      style={{
                        marginTop: '1rem',
                      }}
                      disabled={isSubmitting}
                      onBlur={handleBlur}
                      onChange={handleChange}>
                      <InputLabel style={{ fontSize: '1rem' }} id="select-label-exchange-rates">
                        Moneda
                      </InputLabel>
                      <Field name="Moneda" component={CustomizedSelect}>
                        {currencies.map(c => {
                          return (
                            <MenuItem style={{ fontSize: '0.7em' }} value={c.code}>
                              <ListItemIcon>{c.icon()}</ListItemIcon>
                              {c.label}
                            </MenuItem>
                          );
                        })}
                      </Field>
                    </FormControl>
                  </Box>
                </Grid>


                {values.tipoUsuario === tiposUsuarioValidos.agencia && (
                  <>
                    <Grid item classes={{ root: classes.container }}>
                      <TextField
                        fullWidth
                        name="CodigoLicencia"
                        size="small"
                        classes={{ root: classes.inputText }}
                        label="Código de licencia"
                        variant="outlined"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <ApartmentOutlined />
                            </InputAdornment>
                          ),

                          classes: {
                            input: classes.resize,
                          },
                        }}
                        InputLabelProps={{ style: { fontSize: '0.8em' } }}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={touched.CodigoLicencia && Boolean(errors.CodigoLicencia)}
                        helperText={touched.CodigoLicencia && (errors.CodigoLicencia as string)}
                        disabled={isSubmitting}
                      />
                    </Grid>

                    {values.EsEmpresa && (
                      <Grid item classes={{ root: classes.container }}>
                        <TextField
                          fullWidth
                          name="razonSocial"
                          size="small"
                          classes={{ root: classes.inputText }}
                          label="Razón Social"
                          variant="outlined"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <ApartmentOutlined />
                              </InputAdornment>
                            ),

                            classes: {
                              input: classes.resize,
                            },
                          }}
                          InputLabelProps={{ style: { fontSize: '0.8em' } }}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={touched.razonSocial && Boolean(errors.razonSocial)}
                          helperText={touched.razonSocial && (errors.razonSocial as string)}
                          disabled={isSubmitting}
                          required
                        />
                      </Grid>
                    )}

                    <Grid item classes={{ root: classes.container }}>
                      <TextField
                        fullWidth
                        name="UrlB2B"
                        size="small"
                        classes={{ root: classes.inputText }}
                        label="Link acceso B2B"
                        variant="outlined"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <InsertLinkOutlined />
                            </InputAdornment>
                          ),

                          classes: {
                            input: classes.resize,
                          },
                        }}
                        InputLabelProps={{ style: { fontSize: '0.8em' } }}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={touched.UrlB2B && Boolean(errors.UrlB2B)}
                        helperText={touched.UrlB2B && (errors.UrlB2B as string)}
                        disabled={isSubmitting}
                      />
                    </Grid>

                    <Grid item md={4} xs={12}>
                      <SwitchMUI
                        label="Hotel"
                        name="EsHotel"
                        values={values}
                        setFieldValue={setFieldValue}
                        style={undefined}
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <SwitchMUI
                        label="Margen Configurado en servicios"
                        name="MargenConfiguradoEnServicios"
                        values={values}
                        setFieldValue={setFieldValue}
                        style={undefined}
                      />
                    </Grid>

                    <Grid item classes={{ root: classes.container }}>
                      <SwitchMUI
                        label="Comisiona"
                        name="Comisiona"
                        values={values}
                        setFieldValue={setFieldValue}
                        style={undefined}
                      />
                    </Grid>

                    <Grid item classes={{ root: classes.container }}>
                      <SwitchMUI
                        label="Comisiona por importe"
                        name="ComisionaPorImporte"
                        values={values}
                        setFieldValue={setFieldValue}
                        disabled={isSubmitting || values?.Comisiona === false}
                        style={undefined}
                      />
                    </Grid>

                    <Grid classes={{ root: classes.container }} key="ImporteComision" item>
                      <TextField
                        fullWidth
                        name="ImporteComision"
                        size="small"
                        classes={{ root: classes.inputText }}
                        id={`outlined-basic-ImporteComision`}
                        label={'Importe Comisión'}
                        variant="outlined"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Euro />
                            </InputAdornment>
                          ),
                          classes: {
                            input: classes.resize,
                          },
                        }}
                        InputLabelProps={{ style: { fontSize: '0.8em' } }}
                        value={values['ImporteComision']}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={touched['ImporteComision'] && Boolean(errors['ImporteComision'])}
                        helperText={touched['ImporteComision'] && (errors['ImporteComision'] as string)}
                        disabled={isSubmitting || values?.Comisiona === false || values?.ComisionaPorImporte === false}
                      />
                    </Grid>

                    <Grid classes={{ root: classes.container }} key="ImporteComisionDescuento" item>
                      <TextField
                        fullWidth
                        name="ImporteComisionDescuento"
                        size="small"
                        classes={{ root: classes.inputText }}
                        id={`outlined-basic-ImporteComisionDescuento`}
                        label={'Importe Comisión con descuento'}
                        variant="outlined"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Euro />
                            </InputAdornment>
                          ),
                          classes: {
                            input: classes.resize,
                          },
                        }}
                        InputLabelProps={{ style: { fontSize: '0.8em' } }}
                        value={values['ImporteComisionDescuento']}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={touched['ImporteComisionDescuento'] && Boolean(errors['ImporteComisionDescuento'])}
                        helperText={
                          touched['ImporteComisionDescuento'] && (errors['ImporteComisionDescuento'] as string)
                        }
                        disabled={isSubmitting || values?.Comisiona === false || values?.ComisionaPorImporte === false}
                      />
                    </Grid>

                    <Grid classes={{ root: classes.container }} key="PorcentajeComision" item>
                      <TextField
                        fullWidth
                        name="PorcentajeComision"
                        size="small"
                        classes={{ root: classes.inputText }}
                        id={`outlined-basic-PorcentajeComision`}
                        label={'% Comisión'}
                        variant="outlined"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Euro />
                            </InputAdornment>
                          ),
                          classes: {
                            input: classes.resize,
                          },
                        }}
                        InputLabelProps={{ style: { fontSize: '0.8em' } }}
                        value={values['PorcentajeComision']}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={touched['PorcentajeComision'] && Boolean(errors['PorcentajeComision'])}
                        helperText={touched['PorcentajeComision'] && (errors['PorcentajeComision'] as string)}
                        disabled={isSubmitting || values?.Comisiona === false || values?.ComisionaPorImporte}
                      />
                    </Grid>
                  </>
                )}

                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    p: 2,
                  }}>
                  <Button
                    style={{
                      marginRight: '20px',
                      backgroundColor: '#F39868',
                      color: '#fff',
                      borderRadius: 7,
                      marginLeft: 10,
                    }}
                    onClick={handleCancel}>
                    <Typography style={{ fontWeight: 'bold' }}>Cancelar </Typography>
                  </Button>

                  <LoadingButton
                    loadingPosition="start"
                    variant="contained"
                    type="submit"
                    loading={isSubmitting}
                    disabled={!isValid}
                    style={{
                      backgroundColor: '#E5824F',
                    }}>
                    Añadir
                  </LoadingButton>
                </Box>
              </Grid>
            </Grid>
          </Form>
        )}}
      </Formik>
    </LocalizationProvider>
  );
};
